export function stopScroll (value, margin = true) {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
  const BODY = document.body

  if (value) {
    if (margin) {
      BODY.style.marginRight = scrollbarWidth + 'px'
    }
    BODY.classList.add('overflow')
  } else {
    BODY.style.marginRight = 0 + 'px'
    BODY.classList.remove('overflow')
  }
}
